// extracted by mini-css-extract-plugin
module.exports = {"root":"login-trigger_root__TU4a6"};